import { Box, Paper, Stack, Typography } from '@mui/material'

const VIRIDIS_STOPS = [
  { color: '#440154', label: '0%' },
  { color: '#3b528b', label: '25%' },
  { color: '#21918c', label: '50%' },
  { color: '#5ec962', label: '75%' },
  { color: '#fde725', label: '100%' },
]

const GRADIENT = `linear-gradient(to top, ${VIRIDIS_STOPS.map(s => s.color).join(', ')})`

export const CountyAggregationsLegend = () => {
  return (
    <Paper sx={{ p: 1, mt: 1 }}>
      <Stack spacing={0.5}>
        <Typography variant="caption" fontWeight="bold">
          % of CSB Acres
        </Typography>
        <Stack direction="row" spacing={1}>
          <Box sx={{ width: 16, minHeight: 120, background: GRADIENT, flexShrink: 0 }} />
          <Stack justifyContent="space-between" sx={{ minHeight: 120 }}>
            {[...VIRIDIS_STOPS].reverse().map(({ label }) => (
              <Typography key={label} variant="body2">
                {label}
              </Typography>
            ))}
          </Stack>
        </Stack>
      </Stack>
    </Paper>
  )
}
